import React, {useState} from "react";
import { ExpandMore } from "@mui/icons-material";
import {Accordion, AccordionDetails, AccordionSummary, Grid, Typography, useTheme} from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { IExtensionManagementForm } from "../../models/models";
import { FormAutocomplete, FormDateTimePicker, FormTextField } from "../../common/form-fields-wrappers";

const RaInfo = () => {
    const theme = useTheme();
    const {t} = useTranslation(['network', 'translation']);

    const raExtensionForm = useFormContext<IExtensionManagementForm>();

    const [accordion, setAccordion] = useState(true);

    const requestedDropoffDateList = raExtensionForm.getValues('requestedDropoffDateTimeList');

    const handleAccordionOnChange = (e: React.SyntheticEvent, expanded: boolean) => {
        e.stopPropagation();

        setAccordion(expanded);
    }

    return (
        <Accordion expanded={accordion} onChange={(e, expanded) => handleAccordionOnChange(e, expanded)}>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant={"h6"}>
                    {t("extensionManagement.raInfo.accordion.title")}
                </Typography>
            </AccordionSummary>

            <AccordionDetails>
                <Grid container columnSpacing={2}>
                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormTextField<IExtensionManagementForm>
                            name='raNumber'
                            control={raExtensionForm.control}
                            label={t("extensionManagement.raInfo.form.label.raNumber")}
                            fullWidth
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormAutocomplete<IExtensionManagementForm>
                            name='dmsIdentificationCode'
                            control={raExtensionForm.control}
                            label={t("extensionManagement.raInfo.form.label.dmsIdCode")}
                            fullWidth
                            options={[]}
                            isOptionEqualToValue={(option: any, value: any) => option?.code === value?.code}
                            getOptionLabel={(opt: any) => opt?.description}
                            disabled
                        />
                    </Grid>

                    <Grid container item xs={12} md={6}>
                        <Grid item xs={6} sx={{display: "flex", alignItems: "center"}}>
                            <FormTextField<IExtensionManagementForm>
                                name='renewalsAndSubstitutions'
                                control={raExtensionForm.control}
                                label={t("extensionManagement.raInfo.form.label.renewalsAndSubstitutions")}
                                fullWidth
                                disabled
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormDateTimePicker<IExtensionManagementForm>
                            name="pickUpDate"
                            control={raExtensionForm.control}
                            label={t("extensionManagement.raInfo.form.label.pickUpDate")}
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormAutocomplete<IExtensionManagementForm>
                            name='pickupLocation'
                            control={raExtensionForm.control}
                            label={t("extensionManagement.raInfo.form.label.pickUpLocation")}
                            fullWidth
                            options={[]}
                            isOptionEqualToValue={(option: any, value: any) => option?.code === value?.code}
                            getOptionLabel={(opt: any) => opt?.description}
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormDateTimePicker<IExtensionManagementForm>
                            name="expectedDropoffDate"
                            control={raExtensionForm.control}
                            label={t("extensionManagement.raInfo.form.label.expectedDropOffDate")}
                            disabled
                        />
                    </Grid>

                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                        <FormAutocomplete<IExtensionManagementForm>
                            name='expectedDropoffLocation'
                            control={raExtensionForm.control}
                            label={t("extensionManagement.raInfo.form.label.expectedDropOffLocation")}
                            fullWidth
                            options={[]}
                            isOptionEqualToValue={(option: any, value: any) => option?.code === value?.code}
                            getOptionLabel={(opt: any) => opt?.description}
                            disabled
                        />
                    </Grid>

                    {
                        requestedDropoffDateList?.length > 0 &&
                        <Grid item xs={12} sx={{pt: theme.spacing(2)}}>
                            <Typography variant={"bodyLarge"}>
                                {t("extensionManagement.raInfo.part.extensions")}
                            </Typography>
                        </Grid>
                    }

                    {
                        requestedDropoffDateList
                            .map((extension: any, index: number) =>
                                <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}} key={"reqDropoffDate_" + index}>
                                    <FormDateTimePicker<IExtensionManagementForm>
                                        name={`requestedDropoffDateTimeList.[${index}]`}
                                        control={raExtensionForm.control}
                                        label={t("extensionManagement.raInfo.form.label.requestedDropoffDateTime")}
                                        disabled
                                    />
                                </Grid>
                            )
                    }
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
}

export default RaInfo;